module.exports = __webpack_public_path__ + "static/media/INDONESIA-circle.4cfddd51.svg";